<div class="flex flex-col gap-1 py-3 px-2">
  <!-- Label -->
  <span class="text-sm text-slate-500 font-semibold">
    {{ label }}
  </span>

  <!-- Loading -->
  <ng-container *ngIf="loading; else showValue">
    <p-skeleton width="120px" height="1.25rem"></p-skeleton>
  </ng-container>

  <!-- Value mostrado -->
  <ng-template #showValue>
    <span class="text-base font-semibold text-slate-900" *ngIf="hasValue(value); else noValue">
      {{ value }}
    </span>
  </ng-template>

  <!-- Sin valor -->
  <ng-template #noValue>
    <span class="text-base text-slate-400">-</span>
  </ng-template>
</div>
